import "./src/styles/global.css"

// Keep in-page hash links (e.g. /#services) working after client-side navigation.
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    window.setTimeout(() => {
      const el = document.getElementById(decodeURIComponent(location.hash.slice(1)))
      if (el) el.scrollIntoView()
    }, 0)
    return false
  }
  return true
}
